import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import CreateGamePage from "./pages/CreateGamePage";
import JoinGamePage from "./pages/JoinGamePage";
import GamePage from "./pages/GamePage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import HowToPlayPage from "./pages/HowToPlayPage";
import AboutPage from "./pages/AboutPage";
import FaqPage from "./pages/FaqPage";

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/game/:gameId" element={<GamePage />} />
        <Route path="/join" element={<JoinGamePage />} />
        <Route path="/join/:slug" element={<JoinGamePage />} />
        <Route path="/create" element={<CreateGamePage />} />
        <Route path="/how-to-play" element={<HowToPlayPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route
          path="*"
          element={
            <div className="py-12 text-center text-text-secondary">
              404 — Page not found
            </div>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
